import useSWR from "swr";
import { swrKey } from "@/lib/swr";
import { RouteTabs } from "@/components/nav/route-tabs";
import { Outlet } from "react-router-dom";
import { countSuffix } from "@/lib/utils";
import type { Report } from "@/types/domain";


const Index = () => {
  // Totals for the tab labels — cheap pageSize-1 queries (the tables' own
  // keys vary with pagination/filters, so no dedupe to lean on).
  const one = { pageIndex: 0, pageSize: 1 };
  const { data: versions } = useSWR<{ data: Report[]; total: number }>(
    swrKey("/reports", { ownerType: "version", ...one })
  );
  const { data: prds } = useSWR<{ data: Report[]; total: number }>(
    swrKey("/reports", { ownerType: "prd", ...one })
  );

  const items = [
    {
      name: `Version${countSuffix(versions?.total)}`,
      to: "/reports/versions",
    },
    {
      name: `PRD${countSuffix(prds?.total)}`,
      to: "/reports/prds",
    },
  ];
  return (
    <div className="flex flex-col gap-4">
      <RouteTabs items={items} />
      <Outlet />
    </div>
  );
};

export default Index;
